import { useLocation } from 'react-router-dom';

const useCurrentRoute = () => {
  const location = useLocation();
  return { path: location?.pathname };
};

export default useCurrentRoute;
